import type { MessageKey } from './de';

/**
 * English. Partial on purpose: any missing key falls back to German.
 * To complete the translation, add the remaining keys from de.ts.
 */
export const en: Partial<Record<MessageKey, string>> = {
  'nav.home': 'Home',
  'nav.devices': 'Devices',
  'nav.ride': 'Ride',
  'nav.workouts': 'Workouts',
  'nav.calendar': 'Calendar',
  'nav.routes': 'Routes',
  'nav.rides': 'Rides',
  'nav.group': 'Group ride',
  'nav.settings': 'Settings',
  'nav.debug': 'BLE debug',
  'nav.setup': 'Setup',
  'nav.menu': 'Menu',
  'topbar.trainer': 'Trainer',
  'topbar.hr': 'Heart rate',
  'topbar.notPaired': 'not paired',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.start': 'Start',
  'common.stop': 'Stop',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.connect': 'Connect',
  'common.disconnect': 'Disconnect',
  'common.reconnect': 'Reconnect',
  'common.connected': 'Connected',
  'common.disconnected': 'Disconnected',
  'home.title': 'Hello{name}!',
  'home.today': "Today's workout",
  'home.freeRide': 'Free ride',
  'ride.power': 'Power',
  'ride.cadence': 'Cadence',
  'ride.hr': 'Heart rate',
  'ride.speed': 'Speed',
  'ride.distance': 'Distance',
  'ride.elevation': 'Elevation',
  'ride.time': 'Time',
  'ride.gear': 'Gear',
  'ride.draft': 'Draft {pct} %',
  'settings.title': 'Settings',
  'settings.ftpLocked': 'Your FTP only changes through an FTP test – the result is applied automatically.',
  'onboarding.title': 'Welcome – what is your FTP?',
  'onboarding.lead':
    'FTP (Functional Threshold Power) is the power you can hold for about an hour. Workouts, zones and TSS are based on it.',
  'onboarding.once':
    'You enter it only this once. After that it only changes through an FTP test in the app, which applies the result automatically.',
  'onboarding.ftp': 'FTP (watts)',
  'onboarding.weight': 'Body weight (kg)',
  'onboarding.hint':
    'No idea? Recreational riders are often at 2.5–3.5 W/kg. Enter an estimate and do the ramp test soon.',
  'onboarding.invalid': 'Please enter an FTP between {min} and {max} W.',
  'onboarding.submit': 'Set FTP and start',
  'summary.ftpUpdated': 'New FTP: {ftp} W',
  'summary.ftpUpdatedFrom': 'Applied automatically (was {old} W).',
  'summary.ftpIncomplete': 'FTP test not completed – your FTP stays unchanged.',
  'settings.language': 'Language',
  'ride.fullscreen': 'Fullscreen',
  'ride.discard': 'Discard ride',
  'ride.discardConfirm': 'Really discard? The ride will not be saved.',
  'ride.qualityDowngraded': 'Graphics lowered to "{q}" automatically (low fps)',
  'home.plan': 'Plan',
  'first.title': 'First steps',
  'first.settings': 'FTP and weight entered',
  'first.trainer': 'Pair your trainer (Devices)',
  'first.ride': 'Start your first ride – Lake Zug, Chasseral or your own GPX route',
  'first.hint': 'No trainer at hand? Open the app with ?sim=1 (simulator).',
  'first.dismiss': 'Hide',
  'error.title': 'Something went wrong.',
  'error.hint': 'This view crashed. A running ride is saved every 10 s and can be resumed after reloading.',
  'error.reload': 'Reload',
};
